
export const MENUITEMS = [

    {


        title: 'Dashboard', icon: "bxs:home", active: 1, path: `/Home`, type: 'link', usertype: "All",mobile:"true",desktop:"true"
        // children: [
        //     { path: `${process.env.PUBLIC_URL}/dashboard/default`, title: 'Default', type: 'link' },
        //     { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, title: 'Ecommerce', type: 'link' },
        // ]


    },
    {

        title: 'Trip Details', icon: "bx:trip", active: 2, path: `/Trip_Details`, type: 'link', usertype: "Supplier",mobile:"true",desktop:"true"

    },
    {

        title: 'Trip Details', icon: "bx:trip", active: 3, path: `/Tripdriver`, type: 'link', usertype: "Driver",mobile:"true",desktop:"true"

    },
    {

        title: 'Trip Details', icon: "bx:trip", active: 4, path: `/Tripvehicle`, type: 'link', usertype: "Vehicle Owner",mobile:"true",desktop:"true"

    },
    {

        title: 'Inventory Details', icon: "fa6-solid:warehouse", active: 9, path: `/Inventory_Details`, type: 'link', usertype: "Supplier",mobile:"true",desktop:"true"

    },
    {

        title: 'Vehicle Details', icon: "emojione-monotone:articulated-lorry", active: 10, path: `/Vehicle_Details`, type: 'link', usertype: "Supplier",mobile:"true",desktop:"true"

    },
    {

        title: 'Driver Details', icon: "healthicons:truck-driver", active: 11, path: `/Driver_Details`, type: 'link', usertype: "Supplier",mobile:"true",desktop:"true"

    },
    {

        title: 'Buyer Details', icon: "fa6-solid:building-user", active: 12, path: `/Buyer_Details`, type: 'link', usertype: "Supplier",mobile:"true",desktop:"true"

    },
    {

        title: 'Bill Details', icon: "la:file-invoice", active: 5, path: `/Invoicevehicle`, type: 'link', usertype: "Vehicle Owner",mobile:"true",desktop:"true"

    },
    {

        title: 'Trip Details', icon: "la:file-invoice", active: 7, path: `/Tripbuyer`, type: 'link', usertype: "Buyer",mobile:"true",desktop:"true"

    },
    {

        title: 'Bill Details', icon: "la:file-invoice", active: 8, path: `/Bill_Details`, type: 'link', usertype: "Supplier",mobile:"true",desktop:"true"

    },
    {

        title: 'Account', icon: "bxs:user", active: 19, path: `/Account`, type: 'link', usertype: "All",mobile:"true",desktop:"false"

    },
    {

        title: 'Map', icon: "bxs:map", active: 20, path: `/Map`, type: 'link', usertype: "All",mobile:"true",desktop:"true"

    }
    


]
export const MobileMENUITEMS = [

    {


        title: 'Home', icon: "bxs:home", active: 1, path: `/Home`, type: 'link', usertype: "All"


    },

    {


        title: 'Trip', icon: "bx:trip", active: 2, path: `/Trip_Details`, type: 'link', usertype: "Supplier"

    },
    {


        title: 'Trip', icon: "bx:trip", active: 3, path: `/Tripdriver`, type: 'link', usertype: "Driver"

    },
    {


        title: 'Trip', icon: "bx:trip", active: 4, path: `/Tripvehicle`, type: 'link', usertype: "Vehicle Owner"

    },




    {


        title: 'Invoice', icon: "la:file-invoice", active: 5, path: `/Invoicevehicle`, type: 'link', usertype: "Vehicle Owner"

    },

    {


        title: 'Trip', icon: "la:file-invoice", active: 7, path: `/Tripbuyer`, type: 'link', usertype: "Buyer"


    },
    {


        title: 'Invoice', icon: "la:file-invoice", active: 8, path: `/Bill_Details`, type: 'link', usertype: "Supplier"

    },
    {

        title: 'Account', icon: "bxs:user", active: 19, path: `/Account`, type: 'link', usertype: "All"

    }


]